import { Price } from '../dao/core-dao'
import { coreService } from '../service/core-service'
import { queryKeys } from '../util/query-keys'
import { UseQueryResult, useQuery } from '@tanstack/react-query'

export const usePrices = (): UseQueryResult<Price[], Error> => {
  return useQuery<Price[], Error>(queryKeys.prices(), () => coreService.getPrices(), {
    keepPreviousData: true,
  })
}
